module.exports = __webpack_public_path__ + "img/palm0_3.c072a843.png";